import { Box, CircularProgress, Container, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import orderTracking from '../../assets/images/orderTracking.svg'
import { Gallery_BASE_URL } from '../../config'
import { fetchAddress } from '../../reduxState/addressSlice/addressGetallSlice'
import { fetchOrderById } from '../../reduxState/orderSlice/orderGetbyidSlice'
import { AppDispatch, RootState } from '../../reduxState/store'
import sampleImage from '../../assets/images/sampleInfoImage.png'
import GoToTop from '../commonToast/ontopScroll'
import driverImage from '../../assets/images/image.svg'
import LoadingImage from '../../assets/images/delivery-boy.gif'
import MerchantLoadingImage from "../../assets/images/warningAlert.svg"

const OrderTracking: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const orderList = useSelector((state: RootState) => state.orderById)
  const address = useSelector((state: RootState) => state.addressList);

  React.useEffect(() => {
    dispatch(fetchOrderById(location.state));
  }, [location.state]);

  React.useEffect(() => {
    dispatch(fetchAddress(''))
  }, [])

  console.log('orderList', orderList)

  return (
    <Box className='bg-head' pt={2} pb={4}>
      <Container fixed>
        <Box className='order-box' p={3} px={3} minHeight={'50vh'}>
          <Grid container columns={10.25} justifyContent={'space-between'}>
            {/* Order details */}
            <Grid item xs={10.25} md={7}>
              <Grid container columns={12}>
                {orderList?.data?.orderSts === "OrderCancelled" ?
                  <Grid item xs={12} md={12} lg={12} textAlign={'end'}>
                    <Typography color='#F50000'>{orderList?.data?.orderSts}</Typography> 
                  </Grid>
                  :
                  <>
                    <Grid item xs={0.5} md={0.5} lg={0.5}>
                      <img src={orderTracking} className='order-track-img' alt="Order tracking" style={{ padding: '8px 0' }} loading='lazy' />
                    </Grid>
                    <Grid item pl={3} xs={11.5} md={11.5} lg={11.5} className='responsive-margin'>
                      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography className='order-track-merchant roboto-med'>{orderList?.data?.items[0]?.branch?.branchName}</Typography>
                        {orderList?.data?.orderSts === "OrderDelivered" ?
                            <Typography color='#5F66C6' className='order-track-status roboto-med'>{orderList?.data?.orderSts}</Typography> :
                            orderList?.data?.orderSts === "OrderCancelled" ?
                            <Typography color='#F50000' className='order-track-status roboto-med'>{orderList?.data?.orderSts}</Typography>:
                            orderList?.data?.orderSts === "OrderPlaced" ?
                            <Typography color='#02962B' className='order-track-status roboto-med'>{orderList?.data?.orderSts}</Typography>:
                            <Typography color='#FDA11C' className='order-track-status roboto-med'>{orderList?.data?.orderSts}</Typography>}
                      </Box>
                      <Typography className='order-track-merchant-address roboto-med' sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{orderList?.data?.items[0]?.branch?.branchAddress}</Typography>
                      {address.data.map((item, index) => (
                        item.isDefault === true ?
                          <Box key={index}>
                            {orderList?.data?.orderSts === "OrderDelivered" ? <Typography className='order-track-distance roboto-med' my={1.70}>0</Typography> :
                              <Typography className='order-track-distance roboto-med' my={1.70}>
                                {orderList?.data?.distanceBetweenBranchAndUser}
                              </Typography>}
                            <Typography className='order-track-merchant roboto-med'>{item?.contactName}</Typography>
                            <Typography className='order-track-merchant-address roboto-med'>{`${item?.streetAddress}, ${item?.area}-${item?.zipCode}, ${item?.landMark}`}</Typography>
                          </Box> : null)
                      )}
                    </Grid>
                  </>}
                {/* Driver Deatails */}
                <Grid item xs={12} mt={2}>
                  {orderList?.data?.orderSts === "OrderCancelled" ? null :
                    <Box>
                      {orderList?.data && orderList?.data?.driverDetails ?
                        <>
                          {orderList?.data?.orderSts === "OrderDelivered" ? <Typography className='driver-notification'>Your order delivered by</Typography> :
                            <Typography className='driver-notification'>The driver is on his way to your location...</Typography>}
                          <Box display={'flex'} mt={1} alignItems={'center'}>
                            {orderList?.data?.driverDetails?.profile ?
                              <img src={`${Gallery_BASE_URL}${orderList?.data?.driverDetails?.profile}`} alt="Driver image" className='driver-img' loading='lazy' /> :
                              <img src={driverImage} alt="Driver image" className='driver-img' loading='lazy' />
                            }
                            <Typography sx={{ px: 1.5 }} className='driver-notification'>{orderList?.data?.driverDetails?.driverName}</Typography>
                          </Box>
                        </> :
                        orderList?.data?.orderSts === "OrderPlaced" ?
                        <>
                          <Typography className='driver-notification'>Your Order is Waiting for Restaurant Confirmation. </Typography>
                          <Box display={'flex'} mt={1} alignItems={'center'}>
                            <Box><img src={MerchantLoadingImage} alt="Driver image" className='driver-img' loading='lazy' /></Box>
                            <Typography sx={{ px: 1.5 }} className='driver-notification'>Hang tight, it'll be on its way soon!</Typography>
                          </Box>
                        </>:
                        <>
                          <Typography className='driver-notification'>Driver Hasn't Accepted by Yet, Your Order Awaits Pickup!</Typography>
                          <Box display={'flex'} mt={1} alignItems={'center'}>
                            <Box><img src={LoadingImage} alt="Driver image" className='driver-img' loading='lazy' /></Box>
                            <Typography sx={{ px: 1.5 }} className='driver-notification'>Finding a driver near Restaurant</Typography>
                          </Box>
                        </>}
                    </Box>}
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }} />
                </Grid>
                {/* Products list based on order */}
                <Grid item xs={12}>
                  <Grid container justifyContent={'space-between'}>
                    <Grid item xs={12} textAlign={'end'}>
                      <Typography className='product-list-category-subCategory roboto-med'>{orderList?.data?.orderId}</Typography>
                    </Grid>
                    {orderList?.data?.items.map((order, index) => (
                      <Grid item xs={12} mb={1} key={index}>
                        <Box display={'flex'}>
                          {order?.branch?.image && order?.branch?.image.length > 0 ?
                            <img src={`${Gallery_BASE_URL}${order?.product?.images[0].filePath}`} alt="Merchant Image" width='120px' height='84px' style={{ borderRadius: '18px', objectFit: 'cover' }} loading='lazy' /> :
                            <img src={sampleImage} alt="Merchant Image" width='120px' height='84px' style={{ borderRadius: '18px', objectFit: 'cover' }} loading='lazy' />}
                          <Box px={2} py={1}>
                            <Typography className='product-list-name roboto-med'>{order?.product?.productName}<span style={{ marginLeft: '6px' }}>({order?.variantDetails?.variant?.variantName})</span>{order.prdQty > 1 ? <span> (&#xD7; {order.prdQty})</span> : null}
                            </Typography>
                            <Typography className='product-card-list-category-subcategory roboto-med'>{order?.branch?.categoryTypes.map((cuisine: any) => cuisine.name).join(', ')}</Typography>
                            <Typography className='product-card-price inter-med'>&#x20B9; {order?.variantDetails?.price}</Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Payment Invoice */}
            <Grid item xs={12} md={3}>
              <Box className='order-box' p={2} px={2}>
                <Typography className='order-track-invoice roboto-med'>Invoice</Typography>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} my={1.5}>
                  <Typography className='order-track-item roboto-med'>Item Total</Typography>
                  <Typography className='order-track-item-amount roboto-med'>&#x20B9; {orderList?.data?.totAmt}</Typography>
                </Box>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <Link to="" className='order-track-delivery roboto-med'>Delivery charge</Link>
                  <Typography className='order-track-delivery-amount roboto-med'>&#x20B9; {orderList?.data?.dlvCharges}</Typography>
                </Box>
                {orderList?.data?.isCoupenApplied ?
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} my={1.5}>
                    <Typography className='order-track-item roboto-med'>Coupon amount</Typography>
                    <Typography className='order-track-item-offer-amount roboto-med'>&minus; &#x20B9; {orderList?.data?.coupenAmount}</Typography>
                  </Box> :
                  orderList?.data?.isOfferApplied ?
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} my={1.5}>
                      <Typography className='order-track-item roboto-med'>Offer amount</Typography>
                      <Typography className='order-track-item-amount roboto-med'>&minus; &#x20B9; {orderList?.data?.offerAmount}</Typography>
                    </Box> :
                    null}
                <Divider sx={{ my: 2 }} />
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <Typography className='order-track-item roboto-med'>Sub Total</Typography>
                  <Typography className='order-track-item-amount roboto-med'>&#x20B9; {orderList?.data?.subTotalAmt}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <GoToTop />
        </Box>
      </Container>
    </Box>
  )
}

export default OrderTracking